export const channelTypes = {
  AUTOMATIC_CHANNEL: {
    label: 'خودکار'
  },
  PROMOTED_CHANNEL: {
    label: 'دلخواه'
  },
  LIVE_CHANNEL: {
    label: 'زنده'
  }
}

export const channelStatus = {
  'ACTIVE': {
    label: 'فعال',
    color: 'primary'
  },
  'INACTIVE': {
    label: 'غیر‌فعال',
    color: 'danger'
  }
}

export const channelCountries = {
  'INTERNATIONAL': {
    label: 'همهٔ کشورها',
    color: 'info'
  },
  'IRAN': {
    label: 'ایران',
    color: 'success'
  },
  'NOT_IRAN': {
    label: 'خارج از ایران',
    color: 'dark'
  }
}

export const tagTypes = {
  ORCHESTRATION: 'ساز‌بندی',
  GENRE: 'سبک',
  CURATION: 'کیوریشن',
  MOOD: 'فضا',
  FORM: 'فرم'
}

export const tagContentTypes = {
  'video-clip': 'ویدیوکلیپ',
  'concert': 'کنسرت',
  'interview': 'مصاحبه',
  'podcast-mix': 'پادکست میکس',
  'playlist': 'پلی‌لیست',
  'music': 'موسیقی',
  'audio-book': 'کتاب صوتی',
  'no': ''
};

export const startPointTypes = {
  'NO': 'بدون نقطهٔ شروع',
  ARTIST: 'هنرمند',
  ALBUM: 'آلبوم',
  TRACK: 'آهنگ'
};

export const sortTypes = {
  'DOWNLOAD': 'محبوبیت و تاریخ',
  'DATE': 'تاریخ انتشار',
  'POPULAR': 'محبوبیت',
  'USER_TASTE': 'سلیقهٔ مخاطب',
  'RANDOM_USER_TASTE': 'سلیقهٔ مخاطب تصادفی'
}